<template>
      <div class="accordion-item" >
        <h2 class="accordion-header" :id="'heading' + id">
          <button
            class="accordion-button collapsed custom-accordion-btn"
            type="button"
            data-bs-toggle="collapse"
            :data-bs-target="'#collapse' + object.id"
            aria-expanded="false"
            :aria-controls="'collapse' + object.id"
          >
            {{ object.title }}
          </button>
        </h2>
        <div
          :id="'collapse' + object.id"
          class="accordion-collapse collapse"
          :aria-labelledby="'heading' + index"
          data-bs-parent="#teachingAccordion"
        >
          <div class="accordion-body mt-2">
               <p class="fs-6">
            {{ object.description }}</p><br><br>
             <!--  SLOT HERE to put the cards, any other child component -->
                <div v-if="$slots.default">
                    <slot></slot>
                </div>
          
          </div>
        </div>
      </div>


</template>

<script>
export default {
  //name: 'TeachingView',

   props: ['object']
 
};
</script>

<style scoped>
.accordion-button {
  font-weight: 500;
  font-size: 1.05rem;
}

.custom-accordion-btn {
  background-color: #f8fdf9; /* light green/gray shade */
  color: #198754; /* Bootstrap green */
}

.custom-accordion-btn:not(.collapsed) {
  background-color: #198754;
  color: white;
}

.accordion-item {
  border: 1px solid #dee2e6;
  margin-bottom: 10px;
  border-radius: 6px;
  overflow: hidden;
}

.accordion-body {
  background-color: white;
  color: #333;
  font-size: 0.95rem;
}
</style>
